import { useTranslation } from 'react-i18next';
import Button from '@/components/Button';
import styles from './VerifiedCard.module.scss';

interface VerifiedCardProps {
  onBackToProfile: () => void;
}

const VerifiedCard = ({ onBackToProfile }: VerifiedCardProps) => {
  const { t } = useTranslation(['onboarding']);

  return (
    <section className={styles.card}>
      <h2 className={styles.title}>{t('onboarding:kycVerified.card.title')}</h2>
      <div className={styles.desc}>{t('onboarding:kycVerified.card.desc')}</div>

      <div className={styles.actions}>
        <Button variant="secondary" onClick={onBackToProfile}>
          {t('onboarding:kycVerified.back')}
        </Button>
      </div>
    </section>
  );
};

export default VerifiedCard;
